'use client';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
  useMessageContext,
  IMessage,
  ContextUserType,
} from '@ui/components';
import { Spinner } from '@ui/components/atoms';
import { AlertDialogHeader, AlertDialogFooter } from '@ui/components/ui';
import { useClickOutside } from '@ui/hooks';
import { useEffect, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
interface Props {
  post: IMessage;
  userType: ContextUserType;
  isReply?: boolean;
  open: boolean;
  isModerator: boolean;
  setOpen: (open: boolean) => void;
}
export const PostItemDeleteActionModal = (props: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();
  const params = useSearchParams();
  const messageState = useMessageContext(props.userType);
  const ref = useClickOutside(() => props.setOpen(false));

  const handleDelete = async () => {
    setIsLoading(true);
    await messageState.onDelete(props.post, props.isModerator, props.isReply ? 'reply' : 'comment');
    setIsLoading(false);

    if (params.get('slug') === props.post.slug) {
      if (props.userType === 'fan') {
        router.push(`/creator/community/?slug=${props.post.conversation_id}`);

        return;
      }

      if (params.get('slug') === props.post.slug) {
        router.push('/dashboard/community');
      }
    }
  };

  const preventInteractionOutside = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (messageState.isDeleteMessageSuccess) {
      props.setOpen(false);
    }
  }, [messageState.isDeleteMessageSuccess]);

  return (
    <AlertDialog open={props.open}>
      <div onClick={preventInteractionOutside}>
        <AlertDialogContent ref={ref}>
          <AlertDialogHeader>
            <AlertDialogTitle>Are you sure you want to delete this post?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone.
              {props.isModerator && (
                <p className="mt-2 text-sm text-red-800 p-2 rounded bg-primaryLight">
                  As a moderator, please ensure you have carefully reviewed this post before
                  deletion.
                </p>
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => props.setOpen(false)}>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleDelete}
              disabled={messageState.isDeletingMessage || isLoading}
              className="bg-primary hover:bg-primaryHover">
              {(messageState.isDeletingMessage || isLoading) && (
                <Spinner className="mr-2 animate-spin" fill="#2D3139" />
              )}
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </div>
    </AlertDialog>
  );
};
